import { render, staticRenderFns } from "./ImportCustomer.vue?vue&type=template&id=2a26bb54"
import script from "./ImportCustomer.vue?vue&type=script&lang=js"
export * from "./ImportCustomer.vue?vue&type=script&lang=js"
import style0 from "./ImportCustomer.vue?vue&type=style&index=0&id=2a26bb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports